import * as i0 from '@angular/core';
import { InjectionToken, Inject, Injectable, EventEmitter, ViewChild, Input, Component, NgModule } from '@angular/core';
import * as i3 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { mergeMap, catchError, map, debounceTime, filter, switchMap, concatMap, toArray } from 'rxjs/operators';
import { ReplaySubject, throwError, from } from 'rxjs';
import { DateTime, Duration } from 'luxon';
import * as i1 from 'primeng/api';
import * as i1$1 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i5 from '@angular/forms';
import { UntypedFormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i3$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i4 from 'primeng/accordion';
import { AccordionModule } from 'primeng/accordion';
import { Paginator } from 'primeng/paginator';
import { SelectButton } from 'primeng/selectbutton';
import * as i6 from 'primeng/tabs';
import { TabsModule } from 'primeng/tabs';
const _c0 = ["logfileFooter"];
const _c1 = () => ({
  showAll: "Alle"
});
const _c2 = a0 => [10, 20, 50, 100, 200, a0];
function SpringBootUiComponent_p_tab_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p-tab", 12);
    i0.ɵɵtext(1, "Info");
    i0.ɵɵelementEnd();
  }
}
function SpringBootUiComponent_p_tab_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p-tab", 13);
    i0.ɵɵtext(1, "Metrics");
    i0.ɵɵelementEnd();
  }
}
function SpringBootUiComponent_p_tab_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p-tab", 14);
    i0.ɵɵtext(1, "Environment");
    i0.ɵɵelementEnd();
  }
}
function SpringBootUiComponent_p_tab_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p-tab", 15);
    i0.ɵɵtext(1, "Logging");
    i0.ɵɵelementEnd();
  }
}
function SpringBootUiComponent_p_tab_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p-tab", 16);
    i0.ɵɵtext(1, "Log-File");
    i0.ɵɵelementEnd();
  }
}
function SpringBootUiComponent_p_tab_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p-tab", 17);
    i0.ɵɵtext(1, "Threads");
    i0.ɵɵelementEnd();
  }
}
function SpringBootUiComponent_p_tab_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p-tab", 18);
    i0.ɵɵtext(1, "Bibliotheken");
    i0.ɵɵelementEnd();
  }
}
function SpringBootUiComponent_p_tabpanel_11_div_47_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23)(1, "dl", 30)(2, "dt", 31);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "dd", 31)(5, "div", 32)(6, "div", 33);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(8, "dt", 31);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "dd", 31)(11, "div", 32)(12, "div", 33);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2(" Speicher (", ctx_r0.displayBytes(ctx_r0.memUsed, 2), " / ", ctx_r0.displayBytes(ctx_r0.memMax, 2), ") ");
    i0.ɵɵadvance(3);
    i0.ɵɵstyleProp("width", ctx_r0.memoryPercentage);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.memoryPercentage, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" Heap-Speicher (", ctx_r0.displayBytes(ctx_r0.heapUsed, 2), " / ", ctx_r0.displayBytes(ctx_r0.heapMax, 2), ") ");
    i0.ɵɵadvance(3);
    i0.ɵɵstyleProp("width", ctx_r0.heapMemoryPercentage);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.heapMemoryPercentage, " ");
  }
}
function SpringBootUiComponent_p_tabpanel_11_div_52_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23)(1, "dl", 27)(2, "dt", 25);
    i0.ɵɵtext(3, "Uptime");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "dd", 26);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "dt", 25);
    i0.ɵɵtext(7, "Systemload");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "dd", 26);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "dt", 25);
    i0.ɵɵtext(11, "Prozessoren");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "dd", 26);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.humanizeDuration(ctx_r0.getMetricValue("process.uptime", "VALUE")) || "&nsbp;", " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.getMetricValue("system.load.average.1m", "VALUE") || "&nsbp;", " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.getMetricValue("system.cpu.count", "VALUE") || "&nsbp;", " ");
  }
}
function SpringBootUiComponent_p_tabpanel_11_div_56_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23)(1, "dl", 27)(2, "dt", 25);
    i0.ɵɵtext(3, "Current");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "dd", 26);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "dt", 25);
    i0.ɵɵtext(7, "Total started");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "dd", 26);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "dt", 25);
    i0.ɵɵtext(11, "Daemon");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "dd", 26);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "dt", 25);
    i0.ɵɵtext(15, "Peak");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "dd", 26);
    i0.ɵɵtext(17);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.getMetricValue("jvm.threads.live", "VALUE") || "&nsbp;", " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.getMetricValue("jvm.threads.states", "VALUE") || "&nsbp;", " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.getMetricValue("jvm.threads.daemon", "VALUE") || "&nsbp;", " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.getMetricValue("jvm.threads.peak", "VALUE") || "&nsbp;", " ");
  }
}
function SpringBootUiComponent_p_tabpanel_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p-tabpanel", 12)(1, "div", 19)(2, "div", 20)(3, "div", 21)(4, "div", 22);
    i0.ɵɵtext(5, "Allgemeine Informationen");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 23)(7, "dl", 24)(8, "dt", 25);
    i0.ɵɵtext(9, "Anwendung");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "dd", 26);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "dt", 25);
    i0.ɵɵtext(13, "Beschreibung");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "dd", 26);
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "dt", 25);
    i0.ɵɵtext(17, "Artefakt");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "dd", 26);
    i0.ɵɵtext(19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "dt", 25);
    i0.ɵɵtext(21, "Version");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "dd", 26);
    i0.ɵɵtext(23);
    i0.ɵɵelementEnd()()()()();
    i0.ɵɵelementStart(24, "div", 20)(25, "div", 21)(26, "div", 22);
    i0.ɵɵtext(27, "Git");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "div", 23)(29, "dl", 27)(30, "dt", 25);
    i0.ɵɵtext(31, "Branch");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(32, "dd", 26);
    i0.ɵɵtext(33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "dt", 25);
    i0.ɵɵtext(35, "Commit");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(36, "dd", 26);
    i0.ɵɵtext(37);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(38, "dt", 25);
    i0.ɵɵtext(39, "Commit-Zeit");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(40, "dd", 26);
    i0.ɵɵtext(41);
    i0.ɵɵelementEnd()()()()()();
    i0.ɵɵelementStart(42, "div", 27)(43, "div", 20)(44, "div", 21)(45, "div", 22);
    i0.ɵɵtext(46, "Speicher");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(47, SpringBootUiComponent_p_tabpanel_11_div_47_Template, 14, 10, "div", 28);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(48, "div", 20)(49, "div", 29)(50, "div", 22);
    i0.ɵɵtext(51, "JVM");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(52, SpringBootUiComponent_p_tabpanel_11_div_52_Template, 14, 3, "div", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(53, "div", 21)(54, "div", 22);
    i0.ɵɵtext(55, "Threads");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(56, SpringBootUiComponent_p_tabpanel_11_div_56_Template, 18, 4, "div", 28);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(11);
    i0.ɵɵtextInterpolate((ctx_r0.info == null ? null : ctx_r0.info.build == null ? null : ctx_r0.info.build.name) || "&nsbp;");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate((ctx_r0.info == null ? null : ctx_r0.info.build == null ? null : ctx_r0.info.build.description) || "&nsbp;");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate((ctx_r0.info == null ? null : ctx_r0.info.build == null ? null : ctx_r0.info.build.artifact) || "&nsbp;");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate((ctx_r0.info == null ? null : ctx_r0.info.build == null ? null : ctx_r0.info.build.version) || "&nsbp;");
    i0.ɵɵadvance(10);
    i0.ɵɵtextInterpolate((ctx_r0.info == null ? null : ctx_r0.info.git == null ? null : ctx_r0.info.git.branch) || "&nsbp;");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate((ctx_r0.info == null ? null : ctx_r0.info.git == null ? null : ctx_r0.info.git.commit == null ? null : ctx_r0.info.git.commit.id) || "&nsbp;");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate((ctx_r0.info == null ? null : ctx_r0.info.git == null ? null : ctx_r0.info.git.commit == null ? null : ctx_r0.info.git.commit.time) || "&nsbp;");
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", ctx_r0.metrics);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r0.metrics);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r0.metrics);
  }
}
function SpringBootUiComponent_p_tabpanel_12_tbody_2_tr_4_ng_container_4_br_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "br");
  }
}
function SpringBootUiComponent_p_tabpanel_12_tbody_2_tr_4_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, SpringBootUiComponent_p_tabpanel_12_tbody_2_tr_4_ng_container_4_br_2_Template, 1, 0, "br", 35);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const measurement_r2 = ctx.$implicit;
    const isLast_r3 = ctx.last;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", measurement_r2.statistic, ":\xA0", measurement_r2.value, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !isLast_r3);
  }
}
function SpringBootUiComponent_p_tabpanel_12_tbody_2_tr_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td", 38);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtemplate(4, SpringBootUiComponent_p_tabpanel_12_tbody_2_tr_4_ng_container_4_Template, 3, 3, "ng-container", 37);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const metric_r4 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", metric_r4.name, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", metric_r4.measurements);
  }
}
function SpringBootUiComponent_p_tabpanel_12_tbody_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody")(1, "tr")(2, "th", 36);
    i0.ɵɵtext(3, "Metriken");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(4, SpringBootUiComponent_p_tabpanel_12_tbody_2_tr_4_Template, 5, 2, "tr", 37);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r0.metrics);
  }
}
function SpringBootUiComponent_p_tabpanel_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p-tabpanel", 13)(1, "table", 34);
    i0.ɵɵtemplate(2, SpringBootUiComponent_p_tabpanel_12_tbody_2_Template, 5, 1, "tbody", 35);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.metrics == null ? null : ctx_r0.metrics.length);
  }
}
function SpringBootUiComponent_p_tabpanel_13_table_1_tr_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td", 36);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const innerKey_r5 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(innerKey_r5);
  }
}
function SpringBootUiComponent_p_tabpanel_13_table_1_ng_container_10_tr_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td", 38);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const inner_r6 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(inner_r6.key);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(inner_r6.value.value);
  }
}
function SpringBootUiComponent_p_tabpanel_13_table_1_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "tr")(2, "td", 36);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(4, SpringBootUiComponent_p_tabpanel_13_table_1_ng_container_10_tr_4_Template, 5, 2, "tr", 37);
    i0.ɵɵpipe(5, "keyvalue");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const innerKey_r7 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(innerKey_r7.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(5, 2, innerKey_r7.properties));
  }
}
function SpringBootUiComponent_p_tabpanel_13_table_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "table", 34)(1, "tbody")(2, "tr")(3, "th", 36);
    i0.ɵɵtext(4, "activeProfiles");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(5, SpringBootUiComponent_p_tabpanel_13_table_1_tr_5_Template, 3, 1, "tr", 37);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "tbody")(7, "tr")(8, "th", 36);
    i0.ɵɵtext(9, "propertySources");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(10, SpringBootUiComponent_p_tabpanel_13_table_1_ng_container_10_Template, 6, 4, "ng-container", 37);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", ctx_r0.env.activeProfiles);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", ctx_r0.env.propertySources);
  }
}
function SpringBootUiComponent_p_tabpanel_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p-tabpanel", 14);
    i0.ɵɵtemplate(1, SpringBootUiComponent_p_tabpanel_13_table_1_Template, 11, 2, "table", 39);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.env);
  }
}
function SpringBootUiComponent_p_tabpanel_14_div_12_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Keine Eintr\xE4ge gefunden.");
    i0.ɵɵelementEnd();
  }
}
function SpringBootUiComponent_p_tabpanel_14_div_12_ul_2_li_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 52)(1, "div", 27)(2, "div", 53)(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 54)(6, "div", 55)(7, "p-selectButton", 56);
    i0.ɵɵlistener("ngModelChange", function SpringBootUiComponent_p_tabpanel_14_div_12_ul_2_li_1_Template_p_selectButton_ngModelChange_7_listener($event) {
      const logger_r10 = i0.ɵɵrestoreView(_r9).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0.changeLogLevel(logger_r10, $event));
    });
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const logger_r10 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(logger_r10.name);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r0.logLevels)("ngModel", logger_r10.effectiveLevel);
  }
}
function SpringBootUiComponent_p_tabpanel_14_div_12_ul_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 50);
    i0.ɵɵtemplate(1, SpringBootUiComponent_p_tabpanel_14_div_12_ul_2_li_1_Template, 8, 3, "li", 51);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.pagedLoggers);
  }
}
function SpringBootUiComponent_p_tabpanel_14_div_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵtemplate(1, SpringBootUiComponent_p_tabpanel_14_div_12_span_1_Template, 2, 0, "span", 35)(2, SpringBootUiComponent_p_tabpanel_14_div_12_ul_2_Template, 2, 1, "ul", 49);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.pagedLoggers.length < 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.pagedLoggers.length > 0);
  }
}
function SpringBootUiComponent_p_tabpanel_14_div_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27)(1, "div", 57)(2, "p-paginator", 58);
    i0.ɵɵlistener("onPageChange", function SpringBootUiComponent_p_tabpanel_14_div_14_Template_p_paginator_onPageChange_2_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.updateLoggerSelection($event));
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("showCurrentPageReport", true)("rows", ctx_r0.loggerPageSize)("rowsPerPageOptions", i0.ɵɵpureFunction1(5, _c2, i0.ɵɵpureFunction0(4, _c1)))("totalRecords", ctx_r0.loggers.length);
  }
}
function SpringBootUiComponent_p_tabpanel_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-tabpanel", 15)(1, "div", 21)(2, "div", 22)(3, "strong");
    i0.ɵɵtext(4, "Logger");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "form", 40)(6, "div", 41);
    i0.ɵɵelement(7, "input", 42);
    i0.ɵɵelementStart(8, "span", 43);
    i0.ɵɵelement(9, "i", 44);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "button", 45);
    i0.ɵɵlistener("click", function SpringBootUiComponent_p_tabpanel_14_Template_button_click_10_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.loadLoggers());
    });
    i0.ɵɵelement(11, "i", 46);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵtemplate(12, SpringBootUiComponent_p_tabpanel_14_div_12_Template, 3, 2, "div", 28);
    i0.ɵɵelementStart(13, "div", 47);
    i0.ɵɵtemplate(14, SpringBootUiComponent_p_tabpanel_14_div_14_Template, 3, 7, "div", 48);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("formGroup", ctx_r0.form);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngIf", ctx_r0.pagedLoggers);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.loggers);
  }
}
function SpringBootUiComponent_p_tabpanel_15_div_13_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 67);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.logfile);
  }
}
function SpringBootUiComponent_p_tabpanel_15_div_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23)(1, "div", 64)(2, "div", 27)(3, "div", 65);
    i0.ɵɵtemplate(4, SpringBootUiComponent_p_tabpanel_15_div_13_div_4_Template, 2, 1, "div", 66);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r0.logfile);
  }
}
function SpringBootUiComponent_p_tabpanel_15_div_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 47)(1, "div", 27, 0)(3, "div", 31)(4, "div", 55)(5, "button", 59);
    i0.ɵɵlistener("click", function SpringBootUiComponent_p_tabpanel_15_div_14_Template_button_click_5_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.downloadLogFile($event));
    });
    i0.ɵɵelement(6, "i", 60);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "button", 61);
    i0.ɵɵlistener("click", function SpringBootUiComponent_p_tabpanel_15_div_14_Template_button_click_7_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.loadLogFile($event));
    });
    i0.ɵɵelement(8, "i", 62);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "label", 68)(10, "input", 69);
    i0.ɵɵlistener("click", function SpringBootUiComponent_p_tabpanel_15_div_14_Template_input_click_10_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.toggleScrolling());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(11, "Automatisches Scrollen aktivieren ");
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("disabled", ctx_r0.automaticScrolling);
  }
}
function SpringBootUiComponent_p_tabpanel_15_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-tabpanel", 16)(1, "div", 21)(2, "div", 22)(3, "div", 27)(4, "div", 20)(5, "strong");
    i0.ɵɵtext(6, "Log-File");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 20)(8, "div", 55)(9, "button", 59);
    i0.ɵɵlistener("click", function SpringBootUiComponent_p_tabpanel_15_Template_button_click_9_listener($event) {
      i0.ɵɵrestoreView(_r12);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.downloadLogFile($event));
    });
    i0.ɵɵelement(10, "i", 60);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "button", 61);
    i0.ɵɵlistener("click", function SpringBootUiComponent_p_tabpanel_15_Template_button_click_11_listener($event) {
      i0.ɵɵrestoreView(_r12);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.loadLogFile($event));
    });
    i0.ɵɵelement(12, "i", 62);
    i0.ɵɵelementEnd()()()()();
    i0.ɵɵtemplate(13, SpringBootUiComponent_p_tabpanel_15_div_13_Template, 5, 1, "div", 28)(14, SpringBootUiComponent_p_tabpanel_15_div_14_Template, 12, 1, "div", 63);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(11);
    i0.ɵɵproperty("disabled", ctx_r0.automaticScrolling);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.threads);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.threads);
  }
}
function SpringBootUiComponent_p_tabpanel_16_div_11_p_accordion_panel_2_div_44_div_2_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 80);
    i0.ɵɵtext(1, " native ");
    i0.ɵɵelementEnd();
  }
}
function SpringBootUiComponent_p_tabpanel_16_div_11_p_accordion_panel_2_div_44_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, SpringBootUiComponent_p_tabpanel_16_div_11_p_accordion_panel_2_div_44_div_2_span_5_Template, 2, 0, "span", 79);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const stacktrace_r15 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", stacktrace_r15.className, ".", stacktrace_r15.methodName, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" (", stacktrace_r15.fileName, ":", stacktrace_r15.lineNumber, ") ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", stacktrace_r15.nativeMethod);
  }
}
function SpringBootUiComponent_p_tabpanel_16_div_11_p_accordion_panel_2_div_44_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21)(1, "div", 23);
    i0.ɵɵtemplate(2, SpringBootUiComponent_p_tabpanel_16_div_11_p_accordion_panel_2_div_44_div_2_Template, 6, 5, "div", 37);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const thread_r16 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", thread_r16.stackTrace);
  }
}
function SpringBootUiComponent_p_tabpanel_16_div_11_p_accordion_panel_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p-accordion-panel", 71)(1, "p-accordion-header")(2, "div", 73)(3, "div", 74);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 75);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 76)(8, "span", 77);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(10, "p-accordion-content")(11, "div", 27)(12, "div", 20)(13, "dl", 27)(14, "dt", 25);
    i0.ɵɵtext(15, "Blocked count");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "dd", 26);
    i0.ɵɵtext(17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "dt", 25);
    i0.ɵɵtext(19, "Blocked time");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "dd", 26);
    i0.ɵɵtext(21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "dt", 25);
    i0.ɵɵtext(23, "Waited count");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "dd", 26);
    i0.ɵɵtext(25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "dt", 25);
    i0.ɵɵtext(27, "Waited time");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "dd", 26);
    i0.ɵɵtext(29);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(30, "div", 20)(31, "dl", 27)(32, "dt", 25);
    i0.ɵɵtext(33, "Lock name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "dd", 26);
    i0.ɵɵtext(35);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(36, "dt", 25);
    i0.ɵɵtext(37, "Lock owner id");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(38, "dd", 26);
    i0.ɵɵtext(39);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(40, "dt", 25);
    i0.ɵɵtext(41, "Lock owner name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(42, "dd", 26);
    i0.ɵɵtext(43);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵtemplate(44, SpringBootUiComponent_p_tabpanel_16_div_11_p_accordion_panel_2_div_44_Template, 3, 1, "div", 78);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const thread_r16 = ctx.$implicit;
    const i_r17 = ctx.index;
    i0.ɵɵproperty("value", i_r17);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(thread_r16.threadId);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(thread_r16.threadName);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("label-default", thread_r16.threadState === "NEW")("label-success", thread_r16.threadState === "RUNNABLE")("label-warning", thread_r16.threadState === "BLOCKED" || thread_r16.threadState === "WAITING" || thread_r16.threadState === "TIMED_WAITING")("label-danger", thread_r16.threadState === "TERMINATED");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", thread_r16.threadState, " ");
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate(thread_r16.blockedCount);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(thread_r16.blockedTime);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(thread_r16.waitedCount);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(thread_r16.waitedTime);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(thread_r16.lockName);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(thread_r16.lockOwnerId);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(thread_r16.lockOwnerName);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", thread_r16 == null ? null : thread_r16.stackTrace == null ? null : thread_r16.stackTrace.length);
  }
}
function SpringBootUiComponent_p_tabpanel_16_div_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23)(1, "p-accordion", 71);
    i0.ɵɵtemplate(2, SpringBootUiComponent_p_tabpanel_16_div_11_p_accordion_panel_2_Template, 45, 20, "p-accordion-panel", 72);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.threads);
  }
}
function SpringBootUiComponent_p_tabpanel_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-tabpanel", 17)(1, "div", 21)(2, "div", 22)(3, "div", 27)(4, "div", 20)(5, "strong");
    i0.ɵɵtext(6, "Threads");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 20)(8, "div", 55)(9, "a", 70);
    i0.ɵɵlistener("click", function SpringBootUiComponent_p_tabpanel_16_Template_a_click_9_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.loadThreads($event));
    });
    i0.ɵɵelement(10, "i", 62);
    i0.ɵɵelementEnd()()()()();
    i0.ɵɵtemplate(11, SpringBootUiComponent_p_tabpanel_16_div_11_Template, 3, 2, "div", 28);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(11);
    i0.ɵɵproperty("ngIf", ctx_r0.threads);
  }
}
function SpringBootUiComponent_p_tabpanel_17_tr_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const library_r18 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", library_r18, " ");
  }
}
function SpringBootUiComponent_p_tabpanel_17_div_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27)(1, "div", 57)(2, "p-paginator", 58);
    i0.ɵɵlistener("onPageChange", function SpringBootUiComponent_p_tabpanel_17_div_10_Template_p_paginator_onPageChange_2_listener($event) {
      i0.ɵɵrestoreView(_r19);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.updateLibraryPage($event));
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("showCurrentPageReport", true)("rows", ctx_r0.libraryPageSize)("rowsPerPageOptions", i0.ɵɵpureFunction1(5, _c2, i0.ɵɵpureFunction0(4, _c1)))("totalRecords", ctx_r0.libraries.length);
  }
}
function SpringBootUiComponent_p_tabpanel_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p-tabpanel", 18)(1, "div", 21)(2, "div", 23)(3, "table", 34)(4, "tbody")(5, "tr")(6, "th");
    i0.ɵɵtext(7, "Bibliotheken");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(8, SpringBootUiComponent_p_tabpanel_17_tr_8_Template, 3, 1, "tr", 37);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(9, "div", 47);
    i0.ɵɵtemplate(10, SpringBootUiComponent_p_tabpanel_17_div_10_Template, 3, 7, "div", 48);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("ngForOf", ctx_r0.pagedLibraries);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.libraries);
  }
}
function SpringBootUiComponent_div_20_div_11_p_accordion_panel_2_div_44_div_2_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 80);
    i0.ɵɵtext(1, " native ");
    i0.ɵɵelementEnd();
  }
}
function SpringBootUiComponent_div_20_div_11_p_accordion_panel_2_div_44_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, SpringBootUiComponent_div_20_div_11_p_accordion_panel_2_div_44_div_2_span_5_Template, 2, 0, "span", 79);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const stacktrace_r21 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", stacktrace_r21.className, ".", stacktrace_r21.methodName, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" (", stacktrace_r21.fileName, ":", stacktrace_r21.lineNumber, ") ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", stacktrace_r21.nativeMethod);
  }
}
function SpringBootUiComponent_div_20_div_11_p_accordion_panel_2_div_44_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21)(1, "div", 23);
    i0.ɵɵtemplate(2, SpringBootUiComponent_div_20_div_11_p_accordion_panel_2_div_44_div_2_Template, 6, 5, "div", 37);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const thread_r22 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", thread_r22.stackTrace);
  }
}
function SpringBootUiComponent_div_20_div_11_p_accordion_panel_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p-accordion-panel", 71)(1, "p-accordion-header")(2, "div", 73)(3, "div", 74);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 75);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 76)(8, "span", 77);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(10, "p-accordion-content")(11, "div", 27)(12, "div", 20)(13, "dl", 27)(14, "dt", 25);
    i0.ɵɵtext(15, "Blocked count");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "dd", 26);
    i0.ɵɵtext(17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "dt", 25);
    i0.ɵɵtext(19, "Blocked time");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "dd", 26);
    i0.ɵɵtext(21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "dt", 25);
    i0.ɵɵtext(23, "Waited count");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "dd", 26);
    i0.ɵɵtext(25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "dt", 25);
    i0.ɵɵtext(27, "Waited time");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "dd", 26);
    i0.ɵɵtext(29);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(30, "div", 20)(31, "dl", 27)(32, "dt", 25);
    i0.ɵɵtext(33, "Lock name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "dd", 26);
    i0.ɵɵtext(35);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(36, "dt", 25);
    i0.ɵɵtext(37, "Lock owner id");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(38, "dd", 26);
    i0.ɵɵtext(39);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(40, "dt", 25);
    i0.ɵɵtext(41, "Lock owner name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(42, "dd", 26);
    i0.ɵɵtext(43);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵtemplate(44, SpringBootUiComponent_div_20_div_11_p_accordion_panel_2_div_44_Template, 3, 1, "div", 78);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const thread_r22 = ctx.$implicit;
    const i_r23 = ctx.index;
    i0.ɵɵproperty("value", i_r23);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(thread_r22.threadId);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(thread_r22.threadName);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("label-default", thread_r22.threadState === "NEW")("label-success", thread_r22.threadState === "RUNNABLE")("label-warning", thread_r22.threadState === "BLOCKED" || thread_r22.threadState === "WAITING" || thread_r22.threadState === "TIMED_WAITING")("label-danger", thread_r22.threadState === "TERMINATED");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", thread_r22.threadState, " ");
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate(thread_r22.blockedCount);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(thread_r22.blockedTime);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(thread_r22.waitedCount);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(thread_r22.waitedTime);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(thread_r22.lockName);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(thread_r22.lockOwnerId);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(thread_r22.lockOwnerName);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", thread_r22 == null ? null : thread_r22.stackTrace == null ? null : thread_r22.stackTrace.length);
  }
}
function SpringBootUiComponent_div_20_div_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23)(1, "p-accordion", 71);
    i0.ɵɵtemplate(2, SpringBootUiComponent_div_20_div_11_p_accordion_panel_2_Template, 45, 20, "p-accordion-panel", 72);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.threads);
  }
}
function SpringBootUiComponent_div_20_Template(rf, ctx) {
  if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 81)(1, "div", 21)(2, "div", 22)(3, "div", 27)(4, "div", 20)(5, "strong");
    i0.ɵɵtext(6, "Threads");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 20)(8, "div", 55)(9, "a", 70);
    i0.ɵɵlistener("click", function SpringBootUiComponent_div_20_Template_a_click_9_listener($event) {
      i0.ɵɵrestoreView(_r20);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.loadThreads($event));
    });
    i0.ɵɵelement(10, "i", 62);
    i0.ɵɵelementEnd()()()()();
    i0.ɵɵtemplate(11, SpringBootUiComponent_div_20_div_11_Template, 3, 2, "div", 28);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("show", ctx_r0.activeTab === "threads")("active", ctx_r0.activeTab === "threads");
    i0.ɵɵadvance(11);
    i0.ɵɵproperty("ngIf", ctx_r0.threads);
  }
}
var SpringBootTab;
(function (SpringBootTab) {
  SpringBootTab.details = 'details';
  SpringBootTab.env = 'env';
  SpringBootTab.libraries = 'libraries';
  SpringBootTab.logfile = 'logfile';
  SpringBootTab.logging = 'logging';
  SpringBootTab.metrics = 'metrics';
  SpringBootTab.threads = 'threads';
})(SpringBootTab || (SpringBootTab = {}));
const primeNgMessageKeys = new InjectionToken('prime-ng-message-keys');
const springBootBaseUrl = new InjectionToken('base-url');
const springBootDisableTabs = new InjectionToken('disable-tabs');
/**
 * Konfiguration der Metrik.
 * String[] an regulären Ausdrücken.
 */
const springBootMetricsConfig = new InjectionToken('metric-config');
const springBootLogfileNameTemplate = new InjectionToken('logfile-name-template');
const springBootLogfileAdditionalHeaders = new InjectionToken('logfile-additional-headers');
class AppSettings {
  /**
   * Zwischenspeicher der bereits geladenen Basis-URL.
   * Sollte nie direkt verwendet werden. Stattdessen immer über den
   * `baseUrlGetter()` arbeiten.
   */
  static {
    this.baseUrl = null;
  }
}
function baseUrlGetter() {
  if (!AppSettings.baseUrl) {
    AppSettings.baseUrl = new ReplaySubject(1);
    const base = document.querySelector('base');
    const baseUrl = forceEndsWith(base?.href, '/');
    fetch(baseUrl + 'config.json', {
      method: 'get'
    }).then(res => res.json()).then(json => {
      AppSettings.baseUrl.next(forceEndsWith(json.restUrl, '/'));
      AppSettings.baseUrl.complete();
    }).catch(() => {
      AppSettings.baseUrl.next(location.protocol + '//' + location.host + '/');
      AppSettings.baseUrl.complete();
    });
  }
  return AppSettings.baseUrl;
}
function forceEndsWith(value, endsWith = '/') {
  if (!value) {
    return endsWith;
  }
  return value.endsWith(endsWith) ? value : value + endsWith;
}

/**
 * Für ältere Anwendung steht dieser Service bereit. Dieser kann in die eigene Anwendung kopiert
 * werden und ersetzt den bisherigen BaseCrudService aus ng-kdo-crud, damit nicht jeder Service auf den
 * CrudHelperService umgestellt werden muss. Dieser Service verwendet den CrudHelperService.
 *
 * Folgende Umstellung sind dennoch an den Services notwendig:
 * - CrudHelperService muss als zweiter Parameter übergeben werden
 * - Http muss durch HttpClient ersetzt werden.
 * - Die Parameter oAuthService und config entfallen.
 * - `.map(res => res.json())` muss entfernt werden, da standardmäßig JSON geliefert wird.
 * - Der verwendete NotificationService muss `LegacyNotificationService` implementieren.
 */
class BaseCrudService {
  constructor(endpoint, messageService, router, http, messageKeys) {
    this.endpoint = endpoint;
    this.messageService = messageService;
    this.router = router;
    this.http = http;
    this.sort = {};
    this.filter = [];
    this.size = 10;
    this.page = 1;
    this.messageKeys = this.fillMessageKeys(messageKeys);
  }
  getEndpointUrl() {
    throw {
      name: 'UnsupportedMethodException',
      message: 'Diese Methode wird nicht mehr unterstützt. Bitte verwende Observable.fromPromise wie im CrudHelperService'
    };
  }
  /**
   * Standard-GET-Request an url mit anschließender Fehlerbehandlung.
   * @param url GET-URL
   * @param appendToUrl wird an die URL angehängt
   */
  defaultShareableGET(url, appendToUrl = '') {
    if (appendToUrl) {
      url = url.endsWith('/') ? url + appendToUrl : url + '/' + appendToUrl;
    }
    return baseUrlGetter().pipe(mergeMap(baseUrlAsync => {
      url = baseUrlAsync.endsWith('/') ? baseUrlAsync + url : baseUrlAsync + '/' + url;
      return this.http.get(url);
    }), catchError(error => this.handleErrorEvents(error)));
  }
  /**
   * Laden eines einzelnen Objekts.
   * @param id ID
   * @return hot Observable
   */
  get(id, appendToUrl = '') {
    return this.defaultShareableGET(this.endpoint + '/' + id, appendToUrl);
  }
  /**
   * Fehlerbehandlung. 401- und 500-Fehler behanden.
   * @param {Response} response Serverantwort
   */
  handleErrorEvents(response) {
    // Auth Token abgelaufen
    if (response.status === 401) {
      try {
        if (response.error.error === 'invalid_token') {
          this.onTokenExpired();
          return throwError(() => response);
        }
      } catch (e) {
        // Firefox: response.json().error löst eine Exception aus, wenn der Response-Text
        // nicht im JSON-Format ist
        this.onTokenExpired();
        return throwError(() => response);
      }
    }
    // // Sonstiges Berechtigungsproblem
    if (response.status === 401 || response.status === 403) {
      this.messageService.add({
        detail: 'Sie haben keine Berechtigung für diese Aktion.',
        key: this.messageKeys.error,
        severity: 'error'
      });
    }
    // // Interner Serverfehler
    return this.handleInternalServerError(response);
  }
  handleInternalServerError(response) {
    const json = response.error ? response.error : {
      message: response.message,
      error: response.statusText
    };
    const summary = 'Fehler ' + (response !== null ? '(' + response.status + ' ' + json.error + ')' : '');
    const detail = json ? 'Es ist ein Fehler aufgetreten: ' + json.message : 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.';
    this.messageService.add({
      summary,
      detail,
      severity: 'error',
      key: this.messageKeys.sticky.error,
      sticky: true
    });
    return throwError(() => response);
  }
  onTokenExpired() {
    this.messageService.add({
      detail: 'Ihre Sitzung ist abgelaufen.',
      key: this.messageKeys.error ?? 'main-danger',
      severity: 'error'
    });
    localStorage.removeItem('access_token');
    this.router.navigate(['/login']);
  }
  fillMessageKeys(messageKeys) {
    const defaults = {
      success: 'main',
      info: 'main',
      warning: 'main',
      error: 'main-danger',
      sticky: {
        success: 'main-sticky',
        info: 'main-sticky',
        warning: 'main-sticky',
        error: 'main-sticky'
      }
    };
    const result = Object.assign({}, defaults, messageKeys);
    result.sticky = Object.assign({}, defaults.sticky, messageKeys?.sticky);
    return result;
  }
}
class SpringBootUiService extends BaseCrudService {
  constructor(messageService, router, http, baseUrl, messageKeys, additionalHeaders) {
    super('env', messageService, router, http, messageKeys);
    this.baseUrl = baseUrl;
    this.additionalHeaders = additionalHeaders;
    this.logfileLastRead = 0;
  }
  getEnv() {
    return this.defaultShareableGET(this.baseUrl + '/env');
  }
  getInfo() {
    return this.defaultShareableGET(this.baseUrl + '/info');
  }
  getLibraries() {
    return this.defaultShareableGET(this.baseUrl + '/libraries').pipe(map(response => response.details));
  }
  getLogFile(size = 10240, initialize = false) {
    let headers = new HttpHeaders();
    if (this.additionalHeaders) {
      Object.keys(this.additionalHeaders).forEach(key => {
        headers = headers.set(key, this.additionalHeaders[key]);
      });
    }
    if (initialize) {
      headers = headers.set('Range', `bytes=${(-1 * size).toString(10)}`);
    } else {
      headers = headers.set('Range', `bytes=${this.logfileLastRead.toString(10)}-${(this.logfileLastRead + size).toString(10)}`);
    }
    const url = this.baseUrl + '/logfile?_=' + Math.floor(DateTime.local().toSeconds()).toString(10);
    return baseUrlGetter().pipe(mergeMap(baseUrlAsync => this.http.get(baseUrlAsync + url, {
      headers,
      observe: 'response',
      responseType: 'text'
    })), catchError(error => this.handleErrorEvents(error)), map(response => {
      const range = response.headers.get('content-range') || '';
      const data = range.split(' ')[1];
      const positions = data.split('/')[0];
      const end = positions.split('-')[1];
      this.logfileLastRead = Number.parseInt(end, 10);
      return response.body || '';
    }));
  }
  getLoggers() {
    return this.defaultShareableGET(this.baseUrl + '/loggers').pipe(map(response => response?.loggers || null));
  }
  getMetrics() {
    return this.defaultShareableGET(this.baseUrl + '/metrics').pipe(map(response => response?.names || null));
  }
  getMetricsEntry(metric) {
    return this.defaultShareableGET(this.baseUrl + '/metrics/' + metric);
  }
  getThreads() {
    return this.defaultShareableGET(this.baseUrl + '/threaddump').pipe(map(response => response?.threads || null));
  }
  setLogLevel(logger, logLevel) {
    const headers = new HttpHeaders().set('Content-Type', 'application/json').set('Accept', '*/*');
    return baseUrlGetter().pipe(mergeMap(baseUrlAsync => this.http.post(baseUrlAsync + this.baseUrl + '/loggers/' + logger, logLevel, {
      headers
    })), catchError(error => this.handleErrorEvents(error)));
  }
  static {
    this.ɵfac = function SpringBootUiService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SpringBootUiService)(i0.ɵɵinject(i1.MessageService), i0.ɵɵinject(i1$1.Router), i0.ɵɵinject(i3.HttpClient), i0.ɵɵinject(springBootBaseUrl), i0.ɵɵinject(primeNgMessageKeys), i0.ɵɵinject(springBootLogfileAdditionalHeaders));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SpringBootUiService,
      factory: SpringBootUiService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SpringBootUiService, [{
    type: Injectable
  }], () => [{
    type: i1.MessageService
  }, {
    type: i1$1.Router
  }, {
    type: i3.HttpClient
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [springBootBaseUrl]
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [primeNgMessageKeys]
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [springBootLogfileAdditionalHeaders]
    }]
  }], null);
})();
class SpringBootUiComponent {
  /**
   * Darstellung von mem als Prozentwert.
   */
  get memoryPercentage() {
    if (!this.memMax || !this.memUsed) {
      return '0%';
    }
    return Math.round(100 * this.memUsed / this.memMax) + '%';
  }
  /**
   * Darstellung von heap als Prozentwert.
   */
  get heapMemoryPercentage() {
    if (!this.heapUsed || !this.heapMax) {
      return '0%';
    }
    return Math.round(100 * this.heapUsed / this.heapMax) + '%';
  }
  constructor(cdr, route, service, metricsConfig, logfileNameTemplate, disabledTabs) {
    this.cdr = cdr;
    this.route = route;
    this.service = service;
    this.logfileNameTemplate = logfileNameTemplate;
    this.activeTab = SpringBootTab.details;
    this.availableTabs = [SpringBootTab.details, SpringBootTab.metrics, SpringBootTab.env, SpringBootTab.logging, SpringBootTab.logfile, SpringBootTab.threads, SpringBootTab.libraries];
    this.info = null;
    this.metrics = [];
    this.env = null;
    this.threads = [];
    this.libraries = [];
    this.loggers = [];
    this.logfile = '';
    this.logLevels = ['TRACE', 'DEBUG', 'INFO', 'WARN', 'ERROR', 'OFF'];
    this.pagedLibraries = [];
    this.pagedLoggers = [];
    this.logfileFooterElement = null;
    this.automaticScrolling = false;
    this.loadedRange = 0;
    this.heapUsed = 0;
    this.heapMax = 0;
    this.memUsed = 0;
    this.memMax = 0;
    this.libraryPageSize = 10;
    this.loggerPageSize = 10;
    this.libraryPage = 0;
    this.loggerPage = 0;
    this.destroy$ = new EventEmitter();
    this.metricsConfig = [];
    const fb = new UntypedFormBuilder();
    this.form = fb.group({
      loggerSearchField: ['']
    });
    this.metricsConfig = metricsConfig.map(config => new RegExp(config));
    if (Array.isArray(disabledTabs) && disabledTabs.length) {
      this.availableTabs = this.availableTabs.filter(tab => !disabledTabs.includes(tab));
      if (!this.availableTabs.includes(this.activeTab)) {
        this.activeTab = this.availableTabs[0];
      }
    }
  }
  ngOnInit() {
    this.route.fragment.subscribe(fragment => {
      if (!fragment) {
        return;
      }
      if (this.availableTabs.includes(fragment)) {
        this.activeTab = fragment;
      } else {
        this.activeTab = this.availableTabs[0];
      }
    });
    if (this.availableTabs.includes(SpringBootTab.details)) {
      this.service.getInfo().subscribe(res => {
        this.info = res;
        this.cdr.markForCheck();
      });
    }
    if (this.availableTabs.includes(SpringBootTab.env)) {
      this.service.getEnv().subscribe(res => {
        const activeProfiles = Array.isArray(res?.activeProfiles) && res.activeProfiles.length ? res.activeProfiles : undefined;
        const propertySources = Array.isArray(res?.propertySources) && res.propertySources.length ? res.propertySources : undefined;
        this.env = {
          activeProfiles,
          propertySources
        };
        this.cdr.markForCheck();
      });
    }
    if (this.availableTabs.includes(SpringBootTab.libraries)) {
      const user = window.localStorage.getItem('userName');
      const lsSize = window.localStorage.getItem('size_' + (user ? user : '') + '_springBootLibraries');
      const defSize = 10;
      this.libraryPageSize = lsSize ? Number.parseInt(lsSize, 10) : defSize;
      this.cdr.markForCheck();
      this.loadLibraries();
    }
    if (this.availableTabs.includes(SpringBootTab.logfile)) {
      this.loadLogFile(null, true);
    }
    if (this.availableTabs.includes(SpringBootTab.logging)) {
      const user = window.localStorage.getItem('userName');
      const lsSize = window.localStorage.getItem('size_' + (user ? user : '') + '_springBootLogging');
      const defSize = 10;
      this.loggerPageSize = lsSize ? Number.parseInt(lsSize, 10) : defSize;
      this.cdr.markForCheck();
      this.loadLoggers();
    }
    if (this.availableTabs.includes(SpringBootTab.metrics)) {
      this.loadMetrics();
    }
    if (this.availableTabs.includes(SpringBootTab.threads)) {
      this.loadThreads();
    }
  }
  ngAfterViewInit() {
    this.form.get('loggerSearchField').valueChanges.pipe(debounceTime(400)).subscribe(() => this.loadLoggers());
  }
  ngAfterViewChecked() {
    if (this.logfileFooterElement && this.automaticScrolling) {
      this.logfileFooterElement.nativeElement.scrollIntoView(false);
    }
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
  getMetricValue(query, statistics) {
    if (!this.metrics) {
      return null;
    }
    for (let key = 0; key < this.metrics.length; key++) {
      if (this.metrics[key].name === query) {
        for (const measurement of this.metrics[key].measurements) {
          if (measurement.statistic === statistics) {
            return measurement.value;
          }
        }
      }
    }
    return null;
  }
  /**
   * Bytes in KB, MB, etc. umwandeln.
   */
  displayBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1000;
    const dm = decimals + 1 || 3;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
  humanizeDuration(unixtime) {
    if (unixtime === null) {
      return '';
    }
    if (typeof unixtime === 'string') {
      unixtime = Number.parseInt(unixtime, 10);
    }
    const duration = Duration.fromObject({
      seconds: unixtime
    }, {
      locale: 'de'
    }).shiftTo('years', 'months', 'days', 'hours', 'minutes', 'seconds').toObject();
    const result = [];
    if (duration.years) {
      result.push(duration.years === 1 ? '1 Jahr' : `${duration.years} Jahre`);
    }
    if (duration.months) {
      result.push(duration.months === 1 ? '1 Monat' : `${duration.months} Monate`);
    }
    if (duration.days) {
      result.push(duration.days === 1 ? '1 Tag' : `${duration.days} Tage`);
    }
    if (duration.hours) {
      result.push(duration.hours === 1 ? '1 Stunde' : `${duration.hours} Stunden`);
    }
    if (duration.minutes) {
      result.push(duration.minutes === 1 ? '1 Minute' : `${duration.minutes} Minuten`);
    }
    if (duration.seconds) {
      const seconds = Math.floor(duration.seconds);
      result.push(seconds === 1 ? '1 Sekunde' : `${seconds} Sekunden`);
    }
    return result.join(' ');
  }
  changeLogLevel(logger, logLevel) {
    this.service.setLogLevel(logger.name, {
      configuredLevel: logLevel
    }).subscribe(() => {
      logger.configuredLevel = logLevel;
      this.loadLoggers();
    });
  }
  loadLogFile(event = null, initialize = false) {
    if (event) {
      event.preventDefault();
    }
    this.service.getLogFile(10240, initialize).subscribe(res => {
      if (this.automaticScrolling) {
        setTimeout(() => {
          this.loadLogFile();
        }, 5000);
      }
      const trimmedResponse = res?.trim() ?? '';
      if (trimmedResponse) {
        this.logfile += trimmedResponse + '\r\n';
        this.cdr.markForCheck();
      }
    });
  }
  downloadLogFile(event) {
    event.preventDefault();
    this.service.getLogFile().pipe(filter(res => res !== null)).subscribe(res => {
      const logfileName = this.logfileNameTemplate.replace(/\${(.*?)}/g, this.processLogfileNameTemplate);
      const blob = new Blob([res], {
        type: 'text/plain'
      });
      const link = document.createElement('a');
      const objectUrl = URL.createObjectURL(blob);
      link.href = objectUrl;
      link.download = logfileName;
      document.body.appendChild(link);
      link.click();
      this.cdr.markForCheck();
      setTimeout(() => {
        // ObjectURL wieder entfernen, um Speicherleck zu verhindern
        document.body.removeChild(link);
        URL.revokeObjectURL(objectUrl);
        this.cdr.markForCheck();
      }, 3 * 60 * 1000);
    });
  }
  processLogfileNameTemplate(_match, command) {
    if (!command) {
      return '';
    }
    const actions = command.split(':');
    if (actions[0].toLowerCase() !== 'luxon') {
      return '';
    }
    switch (actions[1].toLowerCase()) {
      case 'iso':
      case 'iso8601':
      case 'toiso':
      case 'toiso8601':
        if (actions[2]?.toLowerCase() === 'true') {
          return DateTime.local().toISO();
        } else {
          return DateTime.utc().toISO();
        }
      case 'json':
      case 'tojson':
        return DateTime.local().toJSON();
      case 'string':
      case 'tostring':
        return DateTime.local().toString();
      case 'localestring':
      case 'tolocalestring':
        return DateTime.local().toLocaleString();
      case 'unix':
        return Math.floor(DateTime.local().toSeconds()).toString(actions[2] ? Number.parseInt(actions[2], 10) : 10);
      case 'format':
        return DateTime.local().toFormat(actions[2]);
      default:
        return DateTime.local().toFormat(actions[1]);
    }
  }
  loadThreads(event = null) {
    if (event) {
      event.preventDefault();
    }
    this.service.getThreads().subscribe(res => {
      if (res) {
        this.threads = res;
      }
      this.cdr.markForCheck();
    });
  }
  loadLibraries(event = null) {
    if (event) {
      event.preventDefault();
    }
    this.service.getLibraries().subscribe(res => {
      if (res) {
        this.libraries = res.sort((a, b) => a.localeCompare(b));
        this.updateLibraryPage();
      }
      this.cdr.markForCheck();
    });
  }
  updateLibraryPage(event) {
    const defaults = {
      first: 0,
      page: 0,
      rows: this.libraryPageSize
    };
    const {
      first,
      page,
      rows
    } = Object.assign(defaults, event ?? {});
    if (this.libraryPageSize && this.libraryPageSize === rows && this.libraryPage && this.libraryPage === page) {
      return;
    }
    this.libraryPage = page;
    this.libraryPageSize = rows;
    const user = window.localStorage.getItem('userName');
    window.localStorage.setItem('size_' + (user ? user : '') + '_springBootLibraries', rows.toString(10));
    // Nur die entsprechende "Seite" anzeigen
    this.pagedLibraries = this.libraries.slice(first, first + rows);
  }
  toggleScrolling() {
    this.automaticScrolling = !this.automaticScrolling;
    this.loadLogFile();
  }
  loadLoggers(event = null) {
    if (event) {
      event.preventDefault();
    }
    const val = this.form.get('loggerSearchField').value?.toLowerCase() ?? '';
    this.service.getLoggers().subscribe(res => {
      if (res === null) {
        return;
      }
      // Logger zurücksetzen und filtern
      this.loggers = [];
      const filteredLoggers = Object.getOwnPropertyNames(res).filter(key => key.toLowerCase().includes(val)).map(key => {
        return {
          name: key,
          configuredLevel: res[key].configuredLevel,
          effectiveLevel: res[key].effectiveLevel
        };
      });
      // Pagination setzen
      this.loggers = filteredLoggers;
      this.updateLoggerSelection();
      this.cdr.markForCheck();
    });
  }
  updateLoggerSelection(event) {
    const defaults = {
      first: 0,
      page: 0,
      rows: this.loggerPageSize
    };
    const {
      first,
      page,
      rows
    } = Object.assign(defaults, event ?? {});
    if (this.loggerPageSize && this.loggerPageSize === rows && this.loggerPage && this.loggerPage === page) {
      return;
    }
    this.loggerPage = page;
    this.loggerPageSize = rows;
    const user = window.localStorage.getItem('userName');
    window.localStorage.setItem('size_' + (user ? user : '') + '_springBootLogging', rows.toString(10));
    // Nur die entsprechende "Seite" anzeigen
    this.pagedLoggers = this.loggers.slice(first, first + rows);
  }
  loadMetrics() {
    this.service.getMetrics().pipe(switchMap(metrics => {
      const metric = metrics?.filter(name => !!this.metricsConfig.find(conf => name.match(conf))) ?? [];
      return from(metric);
    }), concatMap(metric => this.service.getMetricsEntry(metric)), toArray()).subscribe(metrics => {
      this.metrics = this.sortMetric(metrics);
      this.cdr.markForCheck();
    });
    // Used Heap
    this.service.getMetricsEntry('jvm.memory.used?tag=area:heap').subscribe(val => {
      this.heapUsed = val.measurements[0].value;
      this.cdr.markForCheck();
    });
    // Max Heap
    this.service.getMetricsEntry('jvm.memory.max?tag=area:heap').subscribe(val => {
      this.heapMax = val.measurements[0].value;
      this.cdr.markForCheck();
    });
    // Used memory
    this.service.getMetricsEntry('jvm.memory.used?tag=area:nonheap').subscribe(val => {
      this.memUsed = val.measurements[0].value;
      this.cdr.markForCheck();
    });
    // Max memory
    this.service.getMetricsEntry('jvm.memory.max?tag=area:nonheap').subscribe(val => {
      this.memMax = val.measurements[0].value;
      this.cdr.markForCheck();
    });
  }
  sortMetric(arr) {
    return arr.sort((a, b) => {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });
  }
  static {
    this.ɵfac = function SpringBootUiComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SpringBootUiComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1$1.ActivatedRoute), i0.ɵɵdirectiveInject(SpringBootUiService), i0.ɵɵdirectiveInject(springBootMetricsConfig), i0.ɵɵdirectiveInject(springBootLogfileNameTemplate), i0.ɵɵdirectiveInject(springBootDisableTabs));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SpringBootUiComponent,
      selectors: [["spring-boot-ui"]],
      viewQuery: function SpringBootUiComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.logfileFooterElement = _t.first);
        }
      },
      inputs: {
        activeTab: "activeTab"
      },
      features: [i0.ɵɵProvidersFeature([SpringBootUiService])],
      decls: 21,
      vars: 16,
      consts: [["logfileFooter", ""], [1, "m-3"], [3, "valueChange", "value"], ["value", "details", 4, "ngIf"], ["value", "metrics", 4, "ngIf"], ["value", "env", 4, "ngIf"], ["value", "logging", 4, "ngIf"], ["value", "logfile", 4, "ngIf"], ["value", "threads", 4, "ngIf"], ["value", "libraries", 4, "ngIf"], [1, "tab-content"], ["id", "threads", "class", "tab-pane fade", 3, "show", "active", 4, "ngIf"], ["value", "details"], ["value", "metrics"], ["value", "env"], ["value", "logging"], ["value", "logfile"], ["value", "threads"], ["value", "libraries"], [1, "row", "mb-3"], [1, "col-sm-6"], [1, "card"], [1, "card-header"], [1, "card-body"], [1, "row", "row-gap-1"], [1, "col-sm-3", "text-end"], [1, "col-sm-9"], [1, "row"], ["class", "card-body", 4, "ngIf"], [1, "card", "mb-3"], [1, "row", "row-gap-2"], [1, "col-sm-12"], [1, "progress"], ["role", "progressbar", 1, "progress-bar"], [1, "table", "table-striped", "table-break-word"], [4, "ngIf"], ["colspan", "2"], [4, "ngFor", "ngForOf"], [1, "right-align"], ["class", "table table-striped table-break-word", 4, "ngIf"], [3, "formGroup"], [1, "input-group"], ["type", "text", "id", "loggerSearchField", "formControlName", "loggerSearchField", "placeholder", "Suchen", "aria-describedby", "loadLoggerIcon", 1, "form-control"], ["aria-describedby", "refreshLoggerIcon", "id", "loadLoggerIcon", 1, "input-group-text"], [1, "fa", "fa-search"], ["aria-describedby", "moreLoggerIcon", "id", "refreshLoggerIcon", "type", "button", 1, "btn", "btn-outline-secondary", "input-group-addon", 3, "click"], [1, "fa", "fa-refresh"], [1, "card-footer"], ["class", "row", 4, "ngIf"], ["class", "list-group", 4, "ngIf"], [1, "list-group"], ["class", "list-group-item", 4, "ngFor", "ngForOf"], [1, "list-group-item"], [1, "col-sm-8"], [1, "col-sm-4"], [1, "pull-right"], [3, "ngModelChange", "options", "ngModel"], [1, "offset-sm-6", "col-sm-6"], ["currentPageReportTemplate", "Zeige Eintr\xE4ge {first} bis {last} von {totalRecords}.", "styleClass", "pull-right", 3, "onPageChange", "showCurrentPageReport", "rows", "rowsPerPageOptions", "totalRecords"], ["aria-label", "Logfile herunterladen", 1, "btn", "btn-default", 3, "click"], ["aria-hidden", "true", 1, "fa", "fa-download"], ["aria-label", "Logfile aktualisieren", 1, "btn", "btn-default", 3, "click", "disabled"], ["aria-hidden", "true", 1, "fa", "fa-refresh"], ["class", "card-footer", 4, "ngIf"], [1, "container-fluid"], [1, "col-sm-12", "no-float"], ["id", "logfileContent", 4, "ngIf"], ["id", "logfileContent"], [1, "checkbox-inline"], ["type", "checkbox", "value", "", 3, "click"], [1, "btn", "btn-default", 3, "click"], [3, "value"], [3, "value", 4, "ngFor", "ngForOf"], [1, "row", "flex-grow-1", "me-0"], [1, "col-sm-2"], [1, "col-sm-5"], [1, "col-sm-5", "d-flex", "justify-content-end"], [1, "label"], ["class", "card", 4, "ngIf"], ["class", "label label-default", 4, "ngIf"], [1, "label", "label-default"], ["id", "threads", 1, "tab-pane", "fade"]],
      template: function SpringBootUiComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 1)(1, "p-tabs", 2);
          i0.ɵɵtwoWayListener("valueChange", function SpringBootUiComponent_Template_p_tabs_valueChange_1_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.activeTab, $event) || (ctx.activeTab = $event);
            return $event;
          });
          i0.ɵɵelementStart(2, "p-tablist");
          i0.ɵɵtemplate(3, SpringBootUiComponent_p_tab_3_Template, 2, 0, "p-tab", 3)(4, SpringBootUiComponent_p_tab_4_Template, 2, 0, "p-tab", 4)(5, SpringBootUiComponent_p_tab_5_Template, 2, 0, "p-tab", 5)(6, SpringBootUiComponent_p_tab_6_Template, 2, 0, "p-tab", 6)(7, SpringBootUiComponent_p_tab_7_Template, 2, 0, "p-tab", 7)(8, SpringBootUiComponent_p_tab_8_Template, 2, 0, "p-tab", 8)(9, SpringBootUiComponent_p_tab_9_Template, 2, 0, "p-tab", 9);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(10, "p-tabpanels");
          i0.ɵɵtemplate(11, SpringBootUiComponent_p_tabpanel_11_Template, 57, 10, "p-tabpanel", 3)(12, SpringBootUiComponent_p_tabpanel_12_Template, 3, 1, "p-tabpanel", 4)(13, SpringBootUiComponent_p_tabpanel_13_Template, 2, 1, "p-tabpanel", 5)(14, SpringBootUiComponent_p_tabpanel_14_Template, 15, 3, "p-tabpanel", 6)(15, SpringBootUiComponent_p_tabpanel_15_Template, 15, 3, "p-tabpanel", 7)(16, SpringBootUiComponent_p_tabpanel_16_Template, 12, 1, "p-tabpanel", 8)(17, SpringBootUiComponent_p_tabpanel_17_Template, 11, 2, "p-tabpanel", 9);
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(18, "div", 1)(19, "div", 10);
          i0.ɵɵtemplate(20, SpringBootUiComponent_div_20_Template, 12, 5, "div", 11);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵtwoWayProperty("value", ctx.activeTab);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.availableTabs.includes("details"));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.availableTabs.includes("metrics"));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.availableTabs.includes("env"));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.availableTabs.includes("logging"));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.availableTabs.includes("logfile"));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.availableTabs.includes("threads"));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.availableTabs.includes("libraries"));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.availableTabs.includes("details"));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.availableTabs.includes("metrics"));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.availableTabs.includes("env"));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.availableTabs.includes("logging"));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.availableTabs.includes("logfile"));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.availableTabs.includes("threads"));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.availableTabs.includes("libraries"));
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", ctx.availableTabs.includes("threads"));
        }
      },
      dependencies: [CommonModule, i3$1.NgForOf, i3$1.NgIf, i3$1.KeyValuePipe, AccordionModule, i4.Accordion, i4.AccordionPanel, i4.AccordionHeader, i4.AccordionContent, RouterModule, FormsModule, i5.ɵNgNoValidate, i5.DefaultValueAccessor, i5.NgControlStatus, i5.NgControlStatusGroup, i5.NgModel, Paginator, ReactiveFormsModule, i5.FormGroupDirective, i5.FormControlName, SelectButton, TabsModule, i6.Tabs, i6.TabPanels, i6.TabPanel, i6.TabList, i6.Tab],
      styles: [".right-align[_ngcontent-%COMP%]{text-align:right}#logfileContent[_ngcontent-%COMP%]{white-space:pre-wrap}.table-break-word[_ngcontent-%COMP%]{table-layout:fixed;word-wrap:break-word}[_nghost-%COMP%]     .p-accordion-header div.row{flex-grow:1}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SpringBootUiComponent, [{
    type: Component,
    args: [{
      imports: [CommonModule, AccordionModule, RouterModule, FormsModule, Paginator, ReactiveFormsModule, SelectButton, TabsModule],
      providers: [SpringBootUiService],
      selector: 'spring-boot-ui',
      template: "<div class=\"m-3\">\n  <p-tabs [(value)]=\"activeTab\">\n    <p-tablist>\n      <p-tab *ngIf=\"availableTabs.includes('details')\" value=\"details\">Info</p-tab>\n      <p-tab *ngIf=\"availableTabs.includes('metrics')\" value=\"metrics\">Metrics</p-tab>\n      <p-tab *ngIf=\"availableTabs.includes('env')\" value=\"env\">Environment</p-tab>\n      <p-tab *ngIf=\"availableTabs.includes('logging')\" value=\"logging\">Logging</p-tab>\n      <p-tab *ngIf=\"availableTabs.includes('logfile')\" value=\"logfile\">Log-File</p-tab>\n      <p-tab *ngIf=\"availableTabs.includes('threads')\" value=\"threads\">Threads</p-tab>\n      <p-tab *ngIf=\"availableTabs.includes('libraries')\" value=\"libraries\">Bibliotheken</p-tab>\n    </p-tablist>\n\n    <p-tabpanels>\n      <p-tabpanel *ngIf=\"availableTabs.includes('details')\" value=\"details\">\n        <div class=\"row mb-3\">\n          <div class=\"col-sm-6\">\n            <div class=\"card\">\n              <div class=\"card-header\">Allgemeine Informationen</div>\n              <div class=\"card-body\">\n                <dl class=\"row row-gap-1\">\n                  <dt class=\"col-sm-3 text-end\">Anwendung</dt>\n                  <dd class=\"col-sm-9\">{{ info?.build?.name || '&nsbp;' }}</dd>\n                  <dt class=\"col-sm-3 text-end\">Beschreibung</dt>\n                  <dd class=\"col-sm-9\">{{ info?.build?.description || '&nsbp;' }}</dd>\n                  <dt class=\"col-sm-3 text-end\">Artefakt</dt>\n                  <dd class=\"col-sm-9\">{{ info?.build?.artifact || '&nsbp;' }}</dd>\n                  <dt class=\"col-sm-3 text-end\">Version</dt>\n                  <dd class=\"col-sm-9\">{{ info?.build?.version || '&nsbp;' }}</dd>\n                </dl>\n              </div>\n            </div>\n          </div>\n          <div class=\"col-sm-6\">\n            <div class=\"card\">\n              <div class=\"card-header\">Git</div>\n              <div class=\"card-body\">\n                <dl class=\"row\">\n                  <dt class=\"col-sm-3 text-end\">Branch</dt>\n                  <dd class=\"col-sm-9\">{{ info?.git?.branch || '&nsbp;' }}</dd>\n                  <dt class=\"col-sm-3 text-end\">Commit</dt>\n                  <dd class=\"col-sm-9\">{{ info?.git?.commit?.id || '&nsbp;' }}</dd>\n                  <dt class=\"col-sm-3 text-end\">Commit-Zeit</dt>\n                  <dd class=\"col-sm-9\">{{ info?.git?.commit?.time || '&nsbp;' }}</dd>\n                </dl>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"row\">\n          <div class=\"col-sm-6\">\n            <div class=\"card\">\n              <div class=\"card-header\">Speicher</div>\n              <div class=\"card-body\" *ngIf=\"metrics\">\n                <dl class=\"row row-gap-2\">\n                  <dt class=\"col-sm-12\">\n                    Speicher ({{ displayBytes(memUsed, 2) }} /\n                    {{ displayBytes(memMax, 2) }})\n                  </dt>\n                  <dd class=\"col-sm-12\">\n                    <div class=\"progress\">\n                      <div\n                        class=\"progress-bar\"\n                        role=\"progressbar\"\n                        [style.width]=\"memoryPercentage\"\n                      >\n                        {{ memoryPercentage }}\n                      </div>\n                    </div>\n                  </dd>\n                  <dt class=\"col-sm-12\">\n                    Heap-Speicher ({{ displayBytes(heapUsed, 2) }} /\n                    {{ displayBytes(heapMax, 2) }})\n                  </dt>\n                  <dd class=\"col-sm-12\">\n                    <div class=\"progress\">\n                      <div\n                        class=\"progress-bar\"\n                        role=\"progressbar\"\n                        [style.width]=\"heapMemoryPercentage\"\n                      >\n                        {{ heapMemoryPercentage }}\n                      </div>\n                    </div>\n                  </dd>\n                </dl>\n              </div>\n            </div>\n          </div>\n          <div class=\"col-sm-6\">\n            <div class=\"card mb-3\">\n              <div class=\"card-header\">JVM</div>\n              <div class=\"card-body\" *ngIf=\"metrics\">\n                <dl class=\"row\">\n                  <dt class=\"col-sm-3 text-end\">Uptime</dt>\n                  <dd class=\"col-sm-9\">\n                    {{ humanizeDuration(getMetricValue(\"process.uptime\", \"VALUE\")) || '&nsbp;' }}\n                  </dd>\n                  <dt class=\"col-sm-3 text-end\">Systemload</dt>\n                  <dd class=\"col-sm-9\">\n                    {{ getMetricValue(\"system.load.average.1m\", \"VALUE\") || '&nsbp;' }}\n                  </dd>\n                  <dt class=\"col-sm-3 text-end\">Prozessoren</dt>\n                  <dd class=\"col-sm-9\">\n                    {{ getMetricValue(\"system.cpu.count\", \"VALUE\") || '&nsbp;' }}\n                  </dd>\n                </dl>\n              </div>\n            </div>\n\n            <div class=\"card\">\n              <div class=\"card-header\">Threads</div>\n              <div class=\"card-body\" *ngIf=\"metrics\">\n                <dl class=\"row\">\n                  <dt class=\"col-sm-3 text-end\">Current</dt>\n                  <dd class=\"col-sm-9\">\n                    {{ getMetricValue(\"jvm.threads.live\", \"VALUE\") || '&nsbp;' }}\n                  </dd>\n                  <dt class=\"col-sm-3 text-end\">Total started</dt>\n                  <dd class=\"col-sm-9\">\n                    {{ getMetricValue(\"jvm.threads.states\", \"VALUE\") || '&nsbp;' }}\n                  </dd>\n                  <dt class=\"col-sm-3 text-end\">Daemon</dt>\n                  <dd class=\"col-sm-9\">\n                    {{ getMetricValue(\"jvm.threads.daemon\", \"VALUE\") || '&nsbp;' }}\n                  </dd>\n                  <dt class=\"col-sm-3 text-end\">Peak</dt>\n                  <dd class=\"col-sm-9\">\n                    {{ getMetricValue(\"jvm.threads.peak\", \"VALUE\") || '&nsbp;' }}\n                  </dd>\n                </dl>\n              </div>\n            </div>\n          </div>\n        </div>\n      </p-tabpanel>\n\n      <p-tabpanel *ngIf=\"availableTabs.includes('metrics')\" value=\"metrics\">\n        <table class=\"table table-striped table-break-word\">\n          <tbody *ngIf=\"metrics?.length\">\n            <tr>\n              <th colspan=\"2\">Metriken</th>\n            </tr>\n            <tr *ngFor=\"let metric of metrics\">\n              <td class=\"right-align\">\n                {{ metric.name }}\n              </td>\n              <td>\n                <ng-container *ngFor=\"let measurement of metric.measurements; last as isLast\">\n                  {{ measurement.statistic }}:&nbsp;{{ measurement.value }}\n                  <br *ngIf=\"!isLast\" />\n                </ng-container>\n              </td>\n            </tr>\n          </tbody>\n        </table>\n      </p-tabpanel>\n\n      <p-tabpanel *ngIf=\"availableTabs.includes('env')\" value=\"env\">\n        <table *ngIf=\"env\" class=\"table table-striped table-break-word\">\n          <tbody>\n            <tr>\n              <th colspan=\"2\">activeProfiles</th>\n            </tr>\n            <tr *ngFor=\"let innerKey of env.activeProfiles\">\n              <td colspan=\"2\">{{ innerKey }}</td>\n            </tr>\n          </tbody>\n          <tbody>\n            <tr>\n              <th colspan=\"2\">propertySources</th>\n            </tr>\n              <ng-container *ngFor=\"let innerKey of env.propertySources\">\n                <tr>\n                  <td colspan=\"2\">{{ innerKey.name }}</td>\n                </tr>\n                <tr *ngFor=\"let inner of innerKey.properties | keyvalue\">\n                  <td class=\"right-align\">{{ inner.key }}</td>\n                  <td>{{ inner.value.value }}</td>\n                </tr>\n              </ng-container>\n          </tbody>\n        </table>\n      </p-tabpanel>\n\n      <p-tabpanel *ngIf=\"availableTabs.includes('logging')\" value=\"logging\">\n        <div class=\"card\">\n          <div class=\"card-header\">\n            <strong>Logger</strong>\n            <form [formGroup]=\"form\">\n              <div class=\"input-group\">\n                <input\n                  type=\"text\"\n                  id=\"loggerSearchField\"\n                  formControlName=\"loggerSearchField\"\n                  class=\"form-control\"\n                  placeholder=\"Suchen\"\n                  aria-describedby=\"loadLoggerIcon\"\n                />\n                <span\n                  class=\"input-group-text\"\n                  aria-describedby=\"refreshLoggerIcon\"\n                  id=\"loadLoggerIcon\"\n                >\n                  <i class=\"fa fa-search\"></i>\n                </span>\n                <button\n                  aria-describedby=\"moreLoggerIcon\"\n                  class=\"btn btn-outline-secondary input-group-addon\"\n                  (click)=\"loadLoggers()\"\n                  id=\"refreshLoggerIcon\"\n                  type=\"button\"\n                >\n                  <i class=\"fa fa-refresh\"></i>\n                </button>\n              </div>\n            </form>\n          </div>\n          <div class=\"card-body\" *ngIf=\"pagedLoggers\">\n            <span *ngIf=\"pagedLoggers.length < 1\">Keine Eintr\u00E4ge gefunden.</span>\n            <ul class=\"list-group\" *ngIf=\"pagedLoggers.length > 0\">\n              <li\n                class=\"list-group-item\"\n                *ngFor=\"let logger of pagedLoggers; let i = index\"\n              >\n                <div class=\"row\">\n                  <div class=\"col-sm-8\">\n                    <span>{{ logger.name }}</span>\n                  </div>\n                  <div class=\"col-sm-4\">\n                    <div class=\"pull-right\">\n                      <p-selectButton [options]=\"logLevels\" [ngModel]=\"logger.effectiveLevel\" (ngModelChange)=\"changeLogLevel(logger, $event)\"></p-selectButton>\n                    </div>\n                  </div>\n                </div>\n              </li>\n            </ul>\n          </div>\n          <div class=\"card-footer\">\n            <div class=\"row\" *ngIf=\"loggers\">\n              <div class=\"offset-sm-6 col-sm-6\">\n                <p-paginator\n                  currentPageReportTemplate=\"Zeige Eintr\u00E4ge {first} bis {last} von {totalRecords}.\"\n                  [showCurrentPageReport]=\"true\"\n                  styleClass=\"pull-right\"\n                  [rows]=\"loggerPageSize\"\n                  [rowsPerPageOptions]=\"[10,20,50,100,200,{showAll:'Alle'}]\"\n                  [totalRecords]=\"loggers.length\"\n                  (onPageChange)=\"updateLoggerSelection($event)\"></p-paginator>\n              </div>\n            </div>\n          </div>\n        </div>\n      </p-tabpanel>\n\n      <p-tabpanel *ngIf=\"availableTabs.includes('logfile')\" value=\"logfile\">\n        <div class=\"card\">\n          <div class=\"card-header\">\n            <div class=\"row\">\n              <div class=\"col-sm-6\">\n                <strong>Log-File</strong>\n              </div>\n              <div class=\"col-sm-6\">\n                <div class=\"pull-right\">\n                  <button\n                    aria-label=\"Logfile herunterladen\"\n                    class=\"btn btn-default\"\n                    (click)=\"downloadLogFile($event)\" >\n                    <i class=\"fa fa-download\" aria-hidden=\"true\"></i>\n                  </button>\n                  <button\n                    aria-label=\"Logfile aktualisieren\"\n                    class=\"btn btn-default\"\n                    (click)=\"loadLogFile($event)\"\n                    [disabled]=\"automaticScrolling\">\n                    <i class=\"fa fa-refresh\" aria-hidden=\"true\"></i>\n                  </button>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class=\"card-body\" *ngIf=\"threads\">\n            <div class=\"container-fluid\">\n              <div class=\"row\">\n                <div class=\"col-sm-12 no-float\">\n                  <div id=\"logfileContent\" *ngIf=\"logfile\">{{ logfile }}</div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class=\"card-footer\" *ngIf=\"threads\">\n            <div #logfileFooter class=\"row\">\n              <div class=\"col-sm-12\">\n                <div class=\"pull-right\">\n                  <button\n                    aria-label=\"Logfile herunterladen\"\n                    class=\"btn btn-default\"\n                    (click)=\"downloadLogFile($event)\">\n                    <i class=\"fa fa-download\" aria-hidden=\"true\"></i>\n                  </button>\n                  <button\n                    aria-label=\"Logfile aktualisieren\"\n                    class=\"btn btn-default\"\n                    (click)=\"loadLogFile($event)\"\n                    [disabled]=\"automaticScrolling\">\n                    <i class=\"fa fa-refresh\" aria-hidden=\"true\"></i>\n                  </button>\n                  <label class=\"checkbox-inline\">\n                    <input\n                      type=\"checkbox\"\n                      (click)=\"toggleScrolling()\"\n                      value=\"\"\n                    />Automatisches Scrollen aktivieren\n                  </label>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </p-tabpanel>\n\n      <p-tabpanel *ngIf=\"availableTabs.includes('threads')\" value=\"threads\">\n        <div class=\"card\">\n          <div class=\"card-header\">\n            <div class=\"row\">\n              <div class=\"col-sm-6\">\n                <strong>Threads</strong>\n              </div>\n              <div class=\"col-sm-6\">\n                <div class=\"pull-right\">\n                  <a class=\"btn btn-default\" (click)=\"loadThreads($event)\">\n                    <i class=\"fa fa-refresh\" aria-hidden=\"true\"></i>\n                  </a>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class=\"card-body\" *ngIf=\"threads\">\n            <p-accordion [value]=\"0\">\n              <p-accordion-panel\n                *ngFor=\"let thread of threads; let i = index\"\n                [value]=\"i\"\n              >\n                <p-accordion-header>\n                  <div class=\"row flex-grow-1 me-0\">\n                    <div class=\"col-sm-2\">{{ thread.threadId }}</div>\n                    <div class=\"col-sm-5\">{{ thread.threadName }}</div>\n                    <div class=\"col-sm-5 d-flex justify-content-end\">\n                      <span class=\"label\"\n                        [class.label-default]=\"thread.threadState === 'NEW'\"\n                        [class.label-success]=\"thread.threadState === 'RUNNABLE'\"\n                        [class.label-warning]=\"thread.threadState === 'BLOCKED' || thread.threadState === 'WAITING' || thread.threadState === 'TIMED_WAITING'\"\n                        [class.label-danger]=\"thread.threadState === 'TERMINATED'\"\n                      >\n                        {{ thread.threadState }}\n                      </span>\n                    </div>\n                  </div>\n                </p-accordion-header>\n                <p-accordion-content>\n                  <div class=\"row\">\n                    <div class=\"col-sm-6\">\n                      <dl class=\"row\">\n                        <dt class=\"col-sm-3 text-end\">Blocked count</dt>\n                        <dd class=\"col-sm-9\">{{ thread.blockedCount }}</dd>\n\n                        <dt class=\"col-sm-3 text-end\">Blocked time</dt>\n                        <dd class=\"col-sm-9\">{{ thread.blockedTime }}</dd>\n\n                        <dt class=\"col-sm-3 text-end\">Waited count</dt>\n                        <dd class=\"col-sm-9\">{{ thread.waitedCount }}</dd>\n\n                        <dt class=\"col-sm-3 text-end\">Waited time</dt>\n                        <dd class=\"col-sm-9\">{{ thread.waitedTime }}</dd>\n                      </dl>\n                    </div>\n                    <div class=\"col-sm-6\">\n                      <dl class=\"row\">\n                        <dt class=\"col-sm-3 text-end\">Lock name</dt>\n                        <dd class=\"col-sm-9\">{{ thread.lockName }}</dd>\n\n                        <dt class=\"col-sm-3 text-end\">Lock owner id</dt>\n                        <dd class=\"col-sm-9\">{{ thread.lockOwnerId }}</dd>\n\n                        <dt class=\"col-sm-3 text-end\">Lock owner name</dt>\n                        <dd class=\"col-sm-9\">{{ thread.lockOwnerName }}</dd>\n                      </dl>\n                    </div>\n                  </div>\n                  <div *ngIf=\"thread?.stackTrace?.length\" class=\"card\" >\n                    <div class=\"card-body\">\n                      <div *ngFor=\"let stacktrace of thread.stackTrace\">\n                        <span>\n                          {{ stacktrace.className }}.{{ stacktrace.methodName }}\n                        </span>\n                        <span>\n                          ({{ stacktrace.fileName }}:{{ stacktrace.lineNumber }})\n                        </span>\n                        <span *ngIf=\"stacktrace.nativeMethod\"\n                          class=\"label label-default\"\n                          >\n                          native\n                        </span>\n                      </div>\n                    </div>\n                  </div>\n\n                </p-accordion-content>\n              </p-accordion-panel>\n            </p-accordion>\n          </div>\n        </div>\n      </p-tabpanel>\n\n      <p-tabpanel *ngIf=\"availableTabs.includes('libraries')\" value=\"libraries\">\n        <div class=\"card\">\n          <div class=\"card-body\">\n            <table class=\"table table-striped table-break-word\">\n              <tbody>\n                <tr>\n                  <th>Bibliotheken</th>\n                </tr>\n              <tr *ngFor=\"let library of pagedLibraries\">\n                  <td>\n                    {{ library }}\n                  </td>\n                </tr>\n              </tbody>\n            </table>\n          </div>\n          <div class=\"card-footer\">\n            <div class=\"row\" *ngIf=\"libraries\">\n              <div class=\"offset-sm-6 col-sm-6\">\n                <p-paginator\n                    currentPageReportTemplate=\"Zeige Eintr\u00E4ge {first} bis {last} von {totalRecords}.\"\n                    [showCurrentPageReport]=\"true\"\n                    styleClass=\"pull-right\"\n                    [rows]=\"libraryPageSize\"\n                    [rowsPerPageOptions]=\"[10,20,50,100,200,{showAll:'Alle'}]\"\n                    [totalRecords]=\"libraries.length\"\n                    (onPageChange)=\"updateLibraryPage($event)\"></p-paginator>\n              </div>\n            </div>\n          </div>\n        </div>\n      </p-tabpanel>\n\n    </p-tabpanels>\n  </p-tabs>\n</div>\n\n<div class=\"m-3\">\n  <div class=\"tab-content\">\n    <div *ngIf=\"availableTabs.includes('threads')\"\n      id=\"threads\"\n      class=\"tab-pane fade\"\n      [class.show]=\"activeTab === 'threads'\"\n      [class.active]=\"activeTab === 'threads'\"\n    >\n      <div class=\"card\">\n        <div class=\"card-header\">\n          <div class=\"row\">\n            <div class=\"col-sm-6\">\n              <strong>Threads</strong>\n            </div>\n            <div class=\"col-sm-6\">\n              <div class=\"pull-right\">\n                <a class=\"btn btn-default\" (click)=\"loadThreads($event)\">\n                  <i class=\"fa fa-refresh\" aria-hidden=\"true\"></i>\n                </a>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"card-body\" *ngIf=\"threads\">\n          <p-accordion [value]=\"0\">\n            <p-accordion-panel\n              *ngFor=\"let thread of threads; let i = index\"\n              [value]=\"i\"\n            >\n              <p-accordion-header>\n                <div class=\"row flex-grow-1 me-0\">\n                  <div class=\"col-sm-2\">{{ thread.threadId }}</div>\n                  <div class=\"col-sm-5\">{{ thread.threadName }}</div>\n                  <div class=\"col-sm-5 d-flex justify-content-end\">\n                    <span class=\"label\"\n                      [class.label-default]=\"thread.threadState === 'NEW'\"\n                      [class.label-success]=\"thread.threadState === 'RUNNABLE'\"\n                      [class.label-warning]=\"thread.threadState === 'BLOCKED' || thread.threadState === 'WAITING' || thread.threadState === 'TIMED_WAITING'\"\n                      [class.label-danger]=\"thread.threadState === 'TERMINATED'\"\n                    >\n                      {{ thread.threadState }}\n                    </span>\n                  </div>\n                </div>\n              </p-accordion-header>\n              <p-accordion-content>\n                <div class=\"row\">\n                  <div class=\"col-sm-6\">\n                    <dl class=\"row\">\n                      <dt class=\"col-sm-3 text-end\">Blocked count</dt>\n                      <dd class=\"col-sm-9\">{{ thread.blockedCount }}</dd>\n\n                      <dt class=\"col-sm-3 text-end\">Blocked time</dt>\n                      <dd class=\"col-sm-9\">{{ thread.blockedTime }}</dd>\n\n                      <dt class=\"col-sm-3 text-end\">Waited count</dt>\n                      <dd class=\"col-sm-9\">{{ thread.waitedCount }}</dd>\n\n                      <dt class=\"col-sm-3 text-end\">Waited time</dt>\n                      <dd class=\"col-sm-9\">{{ thread.waitedTime }}</dd>\n                    </dl>\n                  </div>\n                  <div class=\"col-sm-6\">\n                    <dl class=\"row\">\n                      <dt class=\"col-sm-3 text-end\">Lock name</dt>\n                      <dd class=\"col-sm-9\">{{ thread.lockName }}</dd>\n\n                      <dt class=\"col-sm-3 text-end\">Lock owner id</dt>\n                      <dd class=\"col-sm-9\">{{ thread.lockOwnerId }}</dd>\n\n                      <dt class=\"col-sm-3 text-end\">Lock owner name</dt>\n                      <dd class=\"col-sm-9\">{{ thread.lockOwnerName }}</dd>\n                    </dl>\n                  </div>\n                </div>\n                <div *ngIf=\"thread?.stackTrace?.length\" class=\"card\" >\n                  <div class=\"card-body\">\n                    <div *ngFor=\"let stacktrace of thread.stackTrace\">\n                      <span>\n                        {{ stacktrace.className }}.{{ stacktrace.methodName }}\n                      </span>\n                      <span>\n                        ({{ stacktrace.fileName }}:{{ stacktrace.lineNumber }})\n                      </span>\n                      <span *ngIf=\"stacktrace.nativeMethod\"\n                        class=\"label label-default\"\n                        >\n                        native\n                      </span>\n                    </div>\n                  </div>\n                </div>\n\n              </p-accordion-content>\n            </p-accordion-panel>\n          </p-accordion>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n",
      styles: [".right-align{text-align:right}#logfileContent{white-space:pre-wrap}.table-break-word{table-layout:fixed;word-wrap:break-word}:host ::ng-deep .p-accordion-header div.row{flex-grow:1}\n"]
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }, {
    type: i1$1.ActivatedRoute
  }, {
    type: SpringBootUiService
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [springBootMetricsConfig]
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [springBootLogfileNameTemplate]
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [springBootDisableTabs]
    }]
  }], {
    activeTab: [{
      type: Input
    }],
    logfileFooterElement: [{
      type: ViewChild,
      args: ['logfileFooter']
    }]
  });
})();
const routes = [{
  path: 'monitoring',
  component: SpringBootUiComponent
}];
class SpringBootUiModule {
  static forRoot(config) {
    return {
      ngModule: SpringBootUiModule,
      providers: [{
        provide: springBootBaseUrl,
        useValue: config.baseUrl
      }, {
        provide: springBootDisableTabs,
        useValue: config.disableTabs || []
      }, {
        provide: springBootMetricsConfig,
        useValue: config.metrics || []
      }, {
        provide: springBootLogfileAdditionalHeaders,
        useValue: config.logfile?.additionalHeaders || {}
      }, {
        provide: springBootLogfileNameTemplate,
        useValue: config.logfile?.nameTemplate || 'spring-boot-logfile-${luxon:unix}.txt'
      }, {
        provide: primeNgMessageKeys,
        useValue: config.primeNgMessageKeys || null
      }]
    };
  }
  static {
    this.ɵfac = function SpringBootUiModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SpringBootUiModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: SpringBootUiModule,
      imports: [i1$1.RouterModule, SpringBootUiComponent],
      exports: [SpringBootUiComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [RouterModule.forChild(routes), SpringBootUiComponent]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SpringBootUiModule, [{
    type: NgModule,
    args: [{
      imports: [RouterModule.forChild(routes), SpringBootUiComponent],
      exports: [SpringBootUiComponent]
    }]
  }], null, null);
})();

/*
 * Public API Surface of spring-boot-ui
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SpringBootTab, SpringBootUiComponent, SpringBootUiModule, SpringBootUiService };
